import { z } from 'zod';

/**
 * `Billing.source` — discriminator for what kind of Hero-sold thing this
 * Billing pays for. Extensible: when Hero starts selling services /
 * hardware / professional services etc., add a new value here.
 *
 * All values carry a `platform_` prefix so they read unambiguously in
 * logs, dashboards, and the Moyasar metadata payload — "is this a
 * platform sale or a freight invoice?" is answered by inspecting the
 * value, not by the collection name.
 *
 * - `platform_subscription`     — periodic subscription charge (the main case in v1)
 * - `platform_addon_recurring`  — a recurring addon billed separately (rare in v1)
 * - `platform_addon_one_time`   — one-off addon purchase (e.g. WhatsApp setup)
 * - `platform_manual`           — admin-issued (custom enterprise invoice / refund)
 *
 * Future values (not in v1): `'platform_professional_services'`,
 * `'platform_hardware_sale'`, `'platform_training'`, `'platform_certification'`.
 */
export const billingSourceSchema = z.enum([
  'platform_subscription',
  'platform_addon_recurring',
  'platform_addon_one_time',
  'platform_manual',
]);
export type BillingSource = z.infer<typeof billingSourceSchema>;
